"use strict";

define('rs/modals/finder/finder.view',['e3-modal'], function (E3Modal) {
  var FinderView = E3Modal.SectionView.extend({
    events: {
      'click .btn-remove-item': 'handleRemoveItemBtnClick',
      'keydown .finder-filter-input': 'handleKeyDownFinderFilterInput',
      'keyup .finder-filter-input': 'handleKeyUpFinderFilterInput'
    },
    templates: {
      'finder.init': 'renderInitFragment',
      'finder.selected': 'renderSelectedFragment'
    },
    render: function render() {
      var delegate = this.getDelegate(),
        props = delegate.getTemplateProperties();
      this.renderInitial(props);
      this.refreshItemsList();
    },
    renderInitial: function renderInitial(props) {
      this.$el.html(this.renderInitFragment(props));
    },
    refreshItemsList: function refreshItemsList() {
      var tableItems = this.getDelegate().tableController.items;
      var columns = this.getDelegate().tableController.columns;
      $(this.el).find('table.e3-table').attr('role', 'presentation');
      $(this.el).find('.clickable').each(function (index) {
        var element = tableItems[index];
        var isSelected = this.className.includes("selected");
        if (element) {
          var content = "";
          columns.forEach(function (column) {
            if (column.displayName) {
              content += column.displayName + " " + (element.item[column.name] || "blank") + "; ";
            }
          });
          $(this).attr({
            'role': 'row',
            'aria-label': 'Row ' + (index + 1) + '; ' + content + (isSelected ? "check mark button selected" : "add button unselected")
          });
        }
      });
      var delegate = this.getDelegate(),
        container = this.getSelectedContainer(),
        itemRows = container.find('.selected-table-body'),
        defaultMsg = container.find('.selected-none-msg'),
        items = _.map(delegate.getItems(), function (item) {
          return {
            displayName: delegate.generateDisplayName(item),
            id: delegate.idProperty ? item[delegate.idProperty] : item.id
          };
        });
      itemRows.empty();
      if (items.length) {
        defaultMsg.hide();
        itemRows.append(this.renderSelectedFragment(items, true));
      } else {
        defaultMsg.show();
      }
    },
    getFilterInput: function getFilterInput() {
      return this.$('.finder-filter-input');
    },
    getFilterValue: function getFilterValue() {
      return this.getFilterInput().val();
    },
    getFinderMsg: function getFinderMsg() {
      return this.$('.finder-msg-txt');
    },
    getItemsContainer: function getItemsContainer() {
      return this.$('.finder-items-container');
    },
    getSelectedContainer: function getSelectedContainer() {
      return this.$('.selected-container');
    },
    enableFilter: function enableFilter() {
      this._disableFilter = false;
    },
    disableFilter: function disableFilter() {
      this._disableFilter = true;
    },
    focusInput: function focusInput() {
      this.getFilterInput().focus();
    },
    handleClearFilterAction: function handleClearFilterAction() {
      this.getFilterInput().val('');
      this.handleFinderFilterAction();
    },
    handleKeyDownFinderFilterInput: function handleKeyDownFinderFilterInput(ev) {
      if (this.isFilterDisabled()) {
        ev.preventDefault();
        ev.stopPropagation();
      }
    },
    handleKeyUpFinderFilterInput: function handleKeyUpFinderFilterInput(ev) {
      var input = $(ev.currentTarget);
      if (ev.keyCode == 27) {
        ev.preventDefault();
        ev.stopPropagation();
        input.val('');
      }
      if (ev.keyCode == 27 || ev.keyCode == 13) {
        this.handleFinderFilterAction();
      }
    },
    handleFinderFilterAction: function handleFinderFilterAction() {},
    handleAddItemBtnClick: function handleAddItemBtnClick() {},
    handleRemoveItemBtnClick: function handleRemoveItemBtnClick(ev) {
      var id = $(ev.currentTarget).closest('.e3-table-row').data('id');
      this.getDelegate().deleteSelectedItem(id);
    },
    handleFilterBtnAction: function handleFilterBtnAction() {
      this.handleFinderFilterAction();
    },
    handleSaveAction: function handleSaveAction() {
      this.getDelegate().requestSaveItems();
    },
    isFilterDisabled: function isFilterDisabled() {
      return !!this._disableFilter;
    },
    resize: function resize() {}
  });
  return FinderView;
});

